import { GRAY_JOB_ISSUE_REQUEST, CREATE_GRAY_JOB_ISSUE, GET_GRAY_JOB_ISSUES, UPDATE_GRAY_JOB_ISSUE, DELETE_GRAY_JOB_ISSUE,
    GRAY_JOB_ISSUE_REQUEST_FAILURE, SET_RECEIVE_RETURN_DETAIL_BY_ID, GET_WEAVER_PARTIES } from '../types';

const initialState = {
  grayJobIssues: [],
  returnReceiveDetail: [],
  weaverParties: [],
  loading: false,
  error: null,
};

const grayJobIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case GRAY_JOB_ISSUE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_GRAY_JOB_ISSUES: {
      return {
        ...state,
        grayJobIssues: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_WEAVER_PARTIES: {
      return {
        ...state,
        weaverParties: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_GRAY_JOB_ISSUE:
      return {
        ...state,
        grayJobIssues: [action.payload, ...state.grayJobIssues],
        loading: false,
        error: null
      };
    case UPDATE_GRAY_JOB_ISSUE:
      const grayJobIssuesData = state.grayJobIssues.slice(0);
      const uIndex = grayJobIssuesData.findIndex((data) => data.id === action.payload.id);
      grayJobIssuesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        grayJobIssues: [ ...grayJobIssuesData ],
        loading: false,
        error: null
      };
    case DELETE_GRAY_JOB_ISSUE:
      const grayJobIssues = state.grayJobIssues?.slice(0);
      const index = grayJobIssues.findIndex((data) => data.id === action.id);
      if (index > -1) {
        grayJobIssues.splice(index, 1);
      }
      return {
        ...state,
        grayJobIssues: [...grayJobIssues],
        loading: false,
        error: null
      }
    case SET_RECEIVE_RETURN_DETAIL_BY_ID: {
      return {
        ...state,
        returnReceiveDetail: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GRAY_JOB_ISSUE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default grayJobIssueReducer;
